<template>
  <div :class="{'productGroup': true, 'is-open': isGroupOpen}">
    <div class="productGroup__header"
         @click="toggleGroup">
      <h3 class="productGroup__header__title">{{data.label}}</h3>
      <div v-if="data.group_switch"
           class="productGroup__header__switch"
           @click.stop>
        <input type="checkbox"
               :id="getIndexedID"
               :name="getIndexedID"/>
        <label :for="getIndexedID"></label>
      </div>
      <div class="productGroup__header__chevron">
        <icon-chevron></icon-chevron>
      </div>
    </div>
    <transition name="slideFromTop">
      <div class="productGroup__content"
           v-show="isGroupOpen">
        <product-item v-for="(item, index) in data.items"
                      :key="index"
                      :info="item"
                      @increment-count="incrementCount"
                      @decrement-count="decrementCount"></product-item>
      </div>
    </transition>
  </div>
</template>

<script>
  import ProductItem from './ProductListingItem';
  import Chevron from './../icons/Chevron';

  export default{
    props: ['data', 'index'],
    data(){
      return{
        group: this.data,
        groupIndex: this.index,
        isOpen: false,
        isSwitched: false,
        totalChildren: 0,
        activeChildren: 0,
        groupID: ''
      }
    },
    watch: {
      activeChildren(){
        var mainSwitch = document.querySelector('#' + this.groupID);
        mainSwitch.checked = this.activeChildren == this.totalChildren;
      }
    },
    computed: {
      getIndexedID(){
        var idx = '';
        if(this.index < 10){
          idx = '0';
        }
        this.groupID = 'group_' + idx + this.index;
        return 'group_' + idx + this.index;
      },
      isGroupOpen(){
        return this.isOpen;
      }
    },
    methods: {
      toggleGroup(){
        this.isOpen = !this.isOpen;
      },
      switchGroup(evt){
        this.isSwitched = evt.target.checked;
        this.$emit('switch-child');
      },
      incrementCount(){
        this.activeChildren++;
        this.sendTotalToParent();
      },
      decrementCount(){
        this.activeChildren--;
        this.sendTotalToParent();
      },
      sendTotalToParent(){
        this.$emit('count-total', this.activeChildren);
      },
      toggleParent(){
        return this.activeChildren == this.totalChildren;
      }
    },
    components: {
      'product-item': ProductItem,
      'icon-chevron': Chevron
    },
    mounted(){
      this.totalChildren = this.data.items.length;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/interactive/ProductListingGroup.vue